module.exports = {
  context: {
    masthead: '@masthead',
    hero: '@homepage-hero',
    notification: '@notification',
    intro: '@intro',
    featuredPages: '@featured-pages',
    iconGroup: '@icon-group',
    featuredStories: '@featured-stories',
    cta: '@cta',
    footer: '@footer'
  }
}
